import { Base64FileData } from 'api/types/data';

import { openLink } from './openLink';

export const convertBase64ToObjectUrl = (base64: string, mimeType?: string) => {
  const byteCharacters = window.atob(base64);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i += 1) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], {
    type: mimeType ?? 'application/octet-stream', // a generic default
  });
  const url = window.URL.createObjectURL(blob);
  return url;
};

export const downloadBase64File = (data: Base64FileData, mimeType?: string) => {
  const url = convertBase64ToObjectUrl(data.base64, mimeType);
  const fileName = `${data.filename}.${data.extension}`;
  openLink(url, fileName);
};
